import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import { rgba } from 'polished';

export const Tooltip = styled(ReactTooltip)`
  &&&& {
    padding: 12px 17px;
    border-radius: 2px;
    background: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
    box-shadow: 0px 0px 4px ${({ theme }) => rgba(theme.colors.common.contrast, 0.25)};
    font-size: 12px;
    line-height: 16px;
    color: #ffffff;
    max-width: ${({ maxWidth }) => (maxWidth ? `${maxWidth}px` : 'auto')};

    a {
      color: #ffffff;
      text-decoration: underline;

      &:hover,
      &:focus {
        color: #ffffff;
      }
    }

    &::after {
      display: block;
      margin-left: -6px;
      transform: rotate(-45deg) skew(8deg, 8deg);
      z-index: 10;
      border-bottom: 6px solid transparent;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid transparent;
      bottom: -5px;
      z-index: -10;
      border-radius: 0px 0px 0px 2px;
    }

    &.place-bottom::after {
      border-top-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
      border-right-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
    }

    &.place-right::after {
      border-top-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
      border-left-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
      margin-left: 0;
    }
    &.place-left::after {
      border-right-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
      border-bottom-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
    }
    &.place-top::after {
      border-left-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
      border-bottom-color: ${({ theme }) => rgba(theme.colors.brand.light.active, 0.9)};
    }

    &.show {
      opacity: 1;
    }
  }
`;
